import { useLocation, useParams } from "react-router-dom";
import { BorderButton } from "src/components/buttons/BorderButton";
import ItemCard from "../items/item/ItemCard";

interface Props {
  privateOfferings?: boolean;
  membershipOfferings?: boolean;
  coupons?: boolean;
  discounts?: boolean;
  fees?: boolean;
  departmentId?: string;
  addons?: boolean;
  offeringId?: string;
  agreements?: boolean;
  infoRequests?: boolean;
  communications?: boolean;
  meets?: boolean;
}

export default function NoOfferings(props: Props) {
  const location = useLocation();
  const match = useParams<{ departmentId: string }>();
  let departmentId = match.departmentId;

  if (props.departmentId) {
    departmentId = props.departmentId;
  }

  let title = "You have no registration offerings.";
  let body = "Create your first registration offering in minutes!";
  let url = "/admin/group-offerings/add";
  let buttonText = "Get Started";

  if (props.privateOfferings) {
    title = "You have no public templates.";
    body = "Create your first public offering template in minutes!";
    url = "/admin/private-offerings/add";
  }

  if (props.membershipOfferings) {
    title = "You have no membership offerings.";
    body = "Create your first membership offering in minutes!";
    url = "/admin/membership-offerings/add";
  }

  if (props.coupons) {
    title = "No coupons found.";
    body = "Adjust the filters or create a new coupon";
    url = `/admin/settings/${departmentId}/coupons/add`;
    buttonText = "Create a coupon";
  }

  if (props.discounts) {
    title = "No discounts found.";
    url = `/admin/settings/${departmentId}/discounts/add`;
    buttonText = "Create a discount";
  }

  if (props.fees) {
    title = `There are no line item fees`;
    body = "You can add a new one.";
    url = `/admin/fees/add`;
  }

  if (props.addons) {
    title = `No products found`;
    buttonText = "Create a product";
    body = "";
    url = `/admin/settings/${departmentId}/addons/add`;
  }

  if (props.agreements) {
    title = `There are no agreements`;
    body = "You can add a new one.";
    url = `/admin/agreements/add`;
  }

  if (props.infoRequests) {
    title = `There are no info requests`;
    body = "You can add a new one.";
    url = `/admin/settings/${departmentId}/student-info-requests/add`;
  }

  if (props.communications) {
    title = `There are no communications`;
    body = "You can add a new one.";
    url = `/admin/communications/templates/add`;
  }

  if (props.offeringId) {
    if (location.pathname.includes("membership-offerings")) {
      url += `?membershipId=${props.offeringId}`;
    } else {
      url += `?groupId=${props.offeringId}`;
    }
  }

  if (props.meets) {
    title = "No active meets found";
    body = null;
    buttonText = "Create or Upload a Meet";
    url = "https://www.swimcloud.com/";
  }

  return (
    <ItemCard loading>
      <div className="pb-8 pt-8 text-center" css={{ background: "#fff" }}>
        <p>
          <strong>{title}</strong>
          <br />
          {body}
        </p>

        {url.startsWith("http") && (
          <BorderButton type="submit" href={url} target="_blank">
            {buttonText}
          </BorderButton>
        )}

        {!url.startsWith("http") && (
          <BorderButton type="submit" to={url}>
            {buttonText}
          </BorderButton>
        )}
      </div>
    </ItemCard>
  );
}
